import axios from 'axios';

// Base API URL - poate fi configurat din environment variables
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Routes API
export const routesAPI = {
  getAllRoutes: async () => {
    try {
      const response = await axios.get(' https://lsqgmcf7ye.execute-api.eu-central-1.amazonaws.com/prod/public/routes');
      if (response.data.success) {
        return response.data.routes;
      }
      return getMockRoutes(); // Fallback to mock data
    } catch (error) {
      console.error('Error fetching routes:', error);
      return getMockRoutes(); // Fallback to mock data
    }
  },

  getRouteById: async (id) => {
    try {
      const response = await axios.get(` https://lsqgmcf7ye.execute-api.eu-central-1.amazonaws.com/prod/public/routes/${id}`);
      if (response.data.success) {
        return response.data.route;
      }
      return null;
    } catch (error) {
      console.error('Error fetching route:', error);
      return null;
    }
  },

  getRouteByNumber: async (numar) => {
    try {
      const response = await axios.get(` https://lsqgmcf7ye.execute-api.eu-central-1.amazonaws.com/prod/public/routes?numar=${numar}`);
      if (response.data.success) {
        return response.data.route;
      }
      return null;
    } catch (error) {
      console.error('Error fetching route:', error);
      return null;
    }
  },

  getRouteSchedule: async (routeId) => {
    try {
      const response = await axios.get(` https://lsqgmcf7ye.execute-api.eu-central-1.amazonaws.com/prod/public/routes/${routeId}`);
      if (response.data.success && response.data.route.curseProgram) {
        return response.data.route.curseProgram;
      }
      return [];
    } catch (error) {
      console.error('Error fetching route schedule:', error);
      return [];
    }
  },
};

// Stations API
export const stationsAPI = {
  getAllStations: async () => {
    try {
      const response = await api.get('/stations');
      return response.data;
    } catch (error) {
      console.error('Error fetching stations:', error);
      return [];
    }
  },

  getStationById: async (id) => {
    try {
      const response = await api.get(`/stations/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching station:', error);
      return null;
    }
  },
};

// Fleet API
export const fleetAPI = {
  getAllVehicles: async () => {
    try {
      const response = await api.get('/fleet');
      return response.data;
    } catch (error) {
      console.error('Error fetching fleet:', error);
      return getMockFleet();
    }
  },

  getVehicleById: async (id) => {
    try {
      const response = await api.get(`/fleet/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching vehicle:', error);
      return null;
    }
  },
};

// Tickets API
export const ticketsAPI = {
  getTicketTypes: async () => {
    try {
      const response = await api.get('/tickets/types');
      return response.data;
    } catch (error) {
      console.error('Error fetching ticket types:', error);
      return getMockTicketTypes();
    }
  },

  purchaseTicket: async (ticketData) => {
    try {
      const response = await api.post('/tickets/purchase', ticketData);
      return response.data;
    } catch (error) {
      console.error('Error purchasing ticket:', error);
      throw error;
    }
  },

  validateTicket: async (ticketId, code) => {
    try {
      const response = await api.post('/tickets/validate', { ticketId, code });
      return response.data;
    } catch (error) {
      console.error('Error validating ticket:', error);
      throw error;
    }
  },
};

// Blog API
export const blogAPI = {
  getAllPosts: async (limit = 10) => {
    try {
      const response = await api.get(`/blog?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching blog posts:', error);
      return getMockBlogPosts();
    }
  },

  getPostById: async (id) => {
    try {
      const response = await api.get(`/blog/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching blog post:', error);
      return null;
    }
  },
};

// Contact API
export const contactAPI = {
  sendMessage: async (contactData) => {
    try {
      const response = await api.post('/contact', contactData);
      return response.data;
    } catch (error) {
      console.error('Error sending contact message:', error);
      throw error;
    }
  },
};

// Mock Data Functions (pentru development când backend-ul nu e disponibil)
function getMockRoutes() {
  return [
    {
      id: '1',
      name: 'Linia 101',
      routeNumber: '101',
      origin: 'Gara Centrală',
      destination: 'Aeroport',
      color: '#2563eb',
      type: 'express',
      distance: 15.5,
      duration: 35,
      frequency: 15,
      stations: [],
      active: true,
    },
    {
      id: '2',
      name: 'Linia 24',
      routeNumber: '24',
      origin: 'Centru',
      destination: 'Cartier Nord',
      color: '#10b981',
      type: 'urban',
      distance: 8.2,
      duration: 25,
      frequency: 10,
      stations: [],
      active: true,
    },
    {
      id: '3',
      name: 'Linia 45',
      routeNumber: '45',
      origin: 'Universitate',
      destination: 'Parc Industrial',
      color: '#f59e0b',
      type: 'urban',
      distance: 12.3,
      duration: 30,
      frequency: 20,
      stations: [],
      active: true,
    },
  ];
}

function getMockFleet() {
  return [
    {
      id: '1',
      name: 'Mercedes Citaro',
      type: 'Autobus Urban',
      capacity: 90,
      features: ['Aer condiționat', 'Wi-Fi', 'USB Charging', 'Acces persoane cu dizabilități'],
      year: 2022,
      fuelType: 'Hybrid',
      image: null,
    },
    {
      id: '2',
      name: 'Solaris Urbino Electric',
      type: 'Autobus Electric',
      capacity: 75,
      features: ['100% Electric', 'Wi-Fi', 'Aer condiționat', 'Încărcare wireless'],
      year: 2023,
      fuelType: 'Electric',
      image: null,
    },
  ];
}

function getMockTicketTypes() {
  return [
    {
      id: '1',
      name: 'Bilet Simplu',
      description: 'Plată per cursă efectuată',
      price: 3,
      currency: 'RON',
      validity: 'per cursă',
      type: 'single',
    },
    {
      id: '2',
      name: 'Abonament Lunar',
      description: 'Călătorii nelimitate pentru 30 zile',
      price: 150,
      currency: 'RON',
      validity: '30 zile',
      type: 'monthly',
    },
  ];
}

function getMockBlogPosts() {
  return [
    // {
    //   id: '1',
    //   title: 'Noi autobuze electrice intră în circulație',
    //   excerpt: 'Am adăugat 10 autobuze electrice Solaris Urbino în flota noastră pentru un transport mai ecologic.',
    //   content: 'Content here...',
    //   image: null,
    //   category: 'Noutăți',
    //   publishedAt: new Date().toISOString(),
    //   author: 'Transport Public',
    // },
    // {
    //   id: '2',
    //   title: 'Program special sărbători',
    //   excerpt: 'Programul de funcționare pentru perioada sărbătorilor de iarnă - vezi modificările de trasee.',
    //   content: 'Content here...',
    //   image: null,
    //   category: 'Anunțuri',
    //   publishedAt: new Date().toISOString(),
    //   author: 'Transport Public',
    // },
  ];
}

export default api;
